import React from "react";
import Container from "../layout/Container";
import { BsStar, BsCheck2, BsTelephone } from "react-icons/bs";
import { TfiAngleRight } from "react-icons/tfi";
import { GiPolarStar } from "react-icons/gi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const PhoneNumber = () => {
  return (
    <Container>
      <div className="mt-2 h-[218px] w-[551px] rounded border border-solid border-darkGreen border-opacity-30">
        <div className="py-4 px-5">
          <div className="flex w-full items-center justify-between">
            <h5 className="font-pop text-xl font-bold text-primary">
              Seller Description
            </h5>
            <div className="flex items-center gap-x-1.5">
              <BsStar className="h-5 w-5 font-pop font-bold text-starIcon" />
              <BsStar className="h-5 w-5 font-pop font-bold text-starIcon" />
              <BsStar className="h-5 w-5 font-pop font-bold text-starIcon" />
              <BsStar className="h-5 w-5 font-pop font-bold text-starIcon" />
              <BsStar className="h-5 w-5 font-pop font-bold text-starIcon" />
            </div>
          </div>
          <div className="mt-2 flex w-full items-center justify-between">
            <div className="flex items-center gap-x-4">
              <div>
                <h5 className="mt-1 font-pop text-base font-bold text-[#222222]">
                  Ben88{" "}
                  <span className="font-pop text-xs font-bold text-primary">
                    (425)
                  </span>
                </h5>
                <div className="flex items-center gap-x-1.5">
                  <div className="rounded-full bg-secondary py-0.5 px-0.5">
                    <BsCheck2 className="font-pop font-bold text-white" />
                  </div>
                  <p className="font-regular font-pop text-sm text-darkGreen text-opacity-60">
                    Email Verified
                  </p>
                </div>
                <div className="mt-1 flex items-center gap-x-1.5">
                  <div className="py-0.5 px-0.5">
                    <FaRegCalendarAlt className="font-pop font-bold text-secondary" />
                  </div>
                  <p className="font-regular font-pop text-sm text-darkGreen text-opacity-60">
                    Joined 9 Sep 2019
                  </p>
                </div>
              </div>
            </div>
            <Link className="flex items-center gap-x-2" to="#">
              <p className="font-regular font-pop text-sm text-primary">
                See listings
              </p>
              <TfiAngleRight />
            </Link>
          </div>
          <div className="mt-6 flex items-center justify-between">
            <div className="flex items-center gap-x-3">
              <BsTelephone className="font-regular font-pop text-2xl text-darkGreen" />
              <p className="font-regular font-pop text-2xl text-darkGreen">
                +2
              </p>
            </div>
            <div className="flex gap-x-2">
              <GiPolarStar />
              <GiPolarStar />
              <GiPolarStar />
              <GiPolarStar />
              <GiPolarStar />
              <GiPolarStar />
            </div>
            <button className="rounded-md bg-primary py-3 px-16 font-pop text-xs font-bold text-white">
              Show number
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PhoneNumber;
